export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.20-1215.39",
  commitId: "f6895051ba1078cb05e1eb64431443c2d94c3bef",
  commitTime: "2026-05-20T12:15:39.000Z",
});
